import { render, staticRenderFns } from "./Fetching.vue?vue&type=template&id=2c2a2b34&"
import script from "./Fetching.vue?vue&type=script&lang=js&"
export * from "./Fetching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports